import type { FaireProductEntity } from "../../entity_types/product";

export const p_krbqmfccbb: FaireProductEntity = {
  token: "p_krbqmfccbb",
  type: "product",
  name: "NEW! ROTHKO STYLE Travel Wrap/Scarf in Silk/Wool Blend",
  brandToken: "b_ipe57bk2",
  brandName: "Margolis Pineo Italia",
  imageUrl:
    "https://cdn.faire.com/fastly/cfd1fea91d951fe012487b818bac61eada82363e70a06c804fae87eb9bdd54f3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf902e8970f7996f746e69ee7a25500fb607a6dc79d42d1a16ecc62e7d49680d.jpeg",
    "https://cdn.faire.com/fastly/e8c7776111aa24f6aaaa428c9b0b51c3e3e28b727ebc99a2fd3ee5d4fdad9dcd.jpeg",
    "https://cdn.faire.com/fastly/cc54b749aec888505136dcbdbcf7eb8705bfeaeb3579d299426ba854d2d54aca.jpeg",
    "https://cdn.faire.com/fastly/e1c0159392ccbb5a84c1a17be1cd6a27cdc338376e3a2eb2e77ca2abdd6939aa.jpeg",
    "https://cdn.faire.com/fastly/c0c0129ce04363c177ac6b296d6a18c21b8e85ab51f8c992ddb349389ce620ca.jpeg",
    "https://cdn.faire.com/fastly/c3116520027459d7219492fc76ae87136e7431b7dcc3fd18c287ddd5e02f60cf.jpeg",
    "https://cdn.faire.com/fastly/602e36216b576b7b2b8d3b5ddd35086e289c65eecc2fe97ea8bb10c6cbf00c30.jpeg",
    "https://cdn.faire.com/fastly/256cdf35141635529ec211bd74fca33e605c40797fefa054a86e1ff2943e4964.jpeg",
    "https://cdn.faire.com/fastly/4dbdcb4a1c998395e0fa85640be31f7a219cd8a027d7c4312a452aa66a14678e.jpeg",
    "https://cdn.faire.com/fastly/930cd80370d76d3d27285a1f84ad3d2592c72ef06479cb2294db1a31ac5b6ea0.jpeg",
    "https://cdn.faire.com/fastly/989d60eaa09ace41f3b4bfee3d99aa63136b633dc354664d641319822820bb6f.jpeg",
    "https://cdn.faire.com/fastly/08185e18fc65a9de2eb64a40781a95b16b50c3aeac2466f1f6925bf152c68597.jpeg",
    "https://cdn.faire.com/fastly/34145f01d420947e82e668cf3854802a87ed330a458e27a2e7eb6076be080364.jpeg",
    "https://cdn.faire.com/fastly/f53cb95e30a03a906e9d4b143c91282aad0f8b2fdad411bccfbe9c06e93e4480.jpeg",
    "https://cdn.faire.com/fastly/cc869e54530df14cb5b7c9e2e9b3003b5855f11949e46ccb89edc324a8fbb3bb.jpeg",
    "https://cdn.faire.com/fastly/a4324f2938276da2b3d7f2bd6e31fc097042636e437081ae35f3eb0bee64b82c.jpeg",
    "https://cdn.faire.com/fastly/484ed118babaa25ec3d60311d4bf6a2561c558819f35794361c8dbc53ae6afb2.jpeg",
    "https://cdn.faire.com/fastly/2eb89d45aff923fe70d1a27a4e4477984b94078daf60f0b2254691e9e10418f5.jpeg",
    "https://cdn.faire.com/fastly/3450c94a916540ef9e91d98f4ecdf43b4a18e4425100a5adb5feeeaf3591574e.jpeg",
    "https://cdn.faire.com/fastly/db98c8d709909d813c754fb1775c9b614da8b6daf984ae2e48493db3fdb42bac.jpeg",
    "https://cdn.faire.com/fastly/3d9ac7dfefea4df178927ea297abd9926b3d4126a76c08b85ef88fb97dea8a32.jpeg",
  ],
  priceDollars: 88,
  description:
    'Our ROTHKO STYLE TRAVEL SCARF/WRAP is a definite WOW! Dressed up or down, this ultra-light, amazingly smooth and soft, extra-fine PAINTERLY Travel Wrap/Scarf is already a museum-quality fave — just restocked and plentiful for YOU! "The Red is Gorgeous!" — Elizabeth\n• 80x36 inches big - perfect for travel, or night on the town\n• 86% lightest, smoothest, softest merino & 14% fine Italian silk\n• Elizabeth\'s arty, four-season favorite, 2024!\n\n\n\n',
  tags: [],
  msrpDollars: 176,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:45.362Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
